import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { OverviewPriorityGroupVinculateComponent } from '../overview-priority-group-vinculate/overview-priority-group-vinculate.component';
import { ModalService } from '../../../modal/modal.service';
import { AlertService } from '../../../alert/alert.service';
import { ProfileAddressesComponent } from '../../../profile-addresses/profile-addresses.component';
import { NavigationExtras } from '@angular/router';
import { NavController } from '@ionic/angular';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';

@Component({
  selector: 'fun-overview-priority-group-detail',
  templateUrl: './overview-priority-group-detail.component.html',
  styleUrls: ['./overview-priority-group-detail.component.scss'],
})
export class OverviewPriorityGroupDetailComponent implements OnInit {

  @Input() public stage: any;
  hasVinculation: boolean = false;
  highestUserPriority: number = null;
  expandedGroups: { [key: number]: boolean } = {};

  constructor(
    public chdRef: ChangeDetectorRef,
    private modalService: ModalService,
    private alertService: AlertService,
    private navCtrl: NavController,
    private localize: LocalizeRouterService
  ) { }

  ngOnInit() {
    this.hasVinculation = this.stage.priority_groups.some((pg: any) => pg.isEnabledForUser);
    // Calcular la prioridad más alta (número más bajo) a la que pertenece el usuario
    const userGroups = this.stage.priority_groups.filter((pg: any) => pg.isEnabledForUser);
    if (userGroups.length > 0) {
      this.highestUserPriority = Math.min.apply(null, userGroups.map((pg: any) => pg.priority));
    }
    this.chdRef.detectChanges();
  }


  get groupedPriorityGroups(): { priority: number, items: any[] }[] {
    if (!this.stage?.priority_groups) return [];

    const sorted = this.stage.priority_groups.slice().sort((a: any, b: any) => a.priority - b.priority);

    const groups: { priority: number, items: any[] }[] = [];
    sorted.forEach((pg: any) => {
      let group = groups.find(g => g.priority === pg.priority);
      if (!group) {
        group = { priority: pg.priority, items: [] };
        groups.push(group);
      }
      group.items.push(pg);
    });

    return groups;
  }

  vinculate(stage) {
    this.alertService.removeModal();
    const params = { stage };
    this.modalService.showModal(OverviewPriorityGroupVinculateComponent, params, '', '', true).subscribe((modal: any) => {
      modal.onClose().subscribe();
      modal.getChildComponent().subscribe((componentRef: OverviewPriorityGroupVinculateComponent) => {
        componentRef.removeComponentEvent.subscribe(() => {
          modal.close();
          this.chdRef.detectChanges();
        });
      });
      this.chdRef.detectChanges();
    });
    this.chdRef.detectChanges();
  }

  parseValues(value: string): string[] {
    if (!value) return [];
    return value.split(',').map(function(v) { return v.trim(); }).filter(function(v) { return v !== ''; });
  }

  toggleExpand(pgId: number): void {
    this.expandedGroups[pgId] = !this.expandedGroups[pgId];
    this.chdRef.detectChanges();
  }

  isExpanded(pgId: number): boolean {
    return !!this.expandedGroups[pgId];
  }

  goToAddAddress() {

    this.alertService.removeModal();
    const navigationExtras: NavigationExtras = {
      state: {
        section: 'addAddresses',
      },
    };
    this.navCtrl.navigateRoot([this.localize.translateRoute('/my-profile')], navigationExtras);
    this.chdRef.detectChanges();
  }

}
